const MessageBox = ({ message, className }) => {
  return (
    <div
      className={
        "flex-container-column small-content table-message " + className
      }
    >
      <p className="m-auto">{message}</p>
    </div>
  );
};

export default MessageBox;
